// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.0-beta.75ecb1238',
  revision: '75ecb1238',
  branch: 'develop',
  date: 'Fri, 10 Jul 2026 15:43:12 GMT'
};